import { SoccerPerformanceCategory } from '../../enums/soccer-performance-category.enum';

export const SOCCER_PERFORMANCE_CATEGORY_BY_MARKET: Record<string, SoccerPerformanceCategory> = {
	Moneyline: SoccerPerformanceCategory.MatchOutcome,
	'1st Half Moneyline': SoccerPerformanceCategory.MatchOutcome,
	'2nd Half Moneyline': SoccerPerformanceCategory.MatchOutcome,
	'Double Chance': SoccerPerformanceCategory.MatchOutcome,
	'1st Half Double Chance': SoccerPerformanceCategory.MatchOutcome,
	'2nd Half Double Chance': SoccerPerformanceCategory.MatchOutcome,
	'Asian Handicap': SoccerPerformanceCategory.MatchOutcome,
	'1st Half Asian Handicap': SoccerPerformanceCategory.MatchOutcome,
	'2nd Half Asian Handicap': SoccerPerformanceCategory.MatchOutcome,
	'Correct Score': SoccerPerformanceCategory.MatchOutcome,
	'1st Half Correct Score': SoccerPerformanceCategory.MatchOutcome,
	'2nd Half Correct Score': SoccerPerformanceCategory.MatchOutcome,
	'Halftime / Fulltime': SoccerPerformanceCategory.MatchOutcome,
	'First Team To Score': SoccerPerformanceCategory.MatchOutcome,

	'Total Goals': SoccerPerformanceCategory.GoalsScoring,
	'1st Half Total Goals': SoccerPerformanceCategory.GoalsScoring,
	'2nd Half Total Goals': SoccerPerformanceCategory.GoalsScoring,
	'Total Goals Odd/Even': SoccerPerformanceCategory.GoalsScoring,
	'Team Total': SoccerPerformanceCategory.GoalsScoring,
	'1st Half Team Total': SoccerPerformanceCategory.GoalsScoring,
	'2nd Half Team Total': SoccerPerformanceCategory.GoalsScoring,
	'Both Teams To Score': SoccerPerformanceCategory.GoalsScoring,
	'1st Half Both Teams To Score': SoccerPerformanceCategory.GoalsScoring,
	'2nd Half Both Teams To Score': SoccerPerformanceCategory.GoalsScoring,
	'Total Shots': SoccerPerformanceCategory.GoalsScoring,
	'Team Total Shots': SoccerPerformanceCategory.GoalsScoring,
	'Total Shots On Target': SoccerPerformanceCategory.GoalsScoring,
	'Team Total Shots On Target': SoccerPerformanceCategory.GoalsScoring,
	'Player Shots': SoccerPerformanceCategory.GoalsScoring,
	'1st Half Player Shots': SoccerPerformanceCategory.GoalsScoring,
	'Player Shots On Target': SoccerPerformanceCategory.GoalsScoring,
	'1st Half Player Shots On Target': SoccerPerformanceCategory.GoalsScoring,
	'Player Goals': SoccerPerformanceCategory.GoalsScoring,
	'Anytime Goal Scorer': SoccerPerformanceCategory.GoalsScoring,
	'First Goal Scorer': SoccerPerformanceCategory.GoalsScoring,
	'Player Goals + Assists': SoccerPerformanceCategory.GoalsScoring,
	'Player To Score Or Assist': SoccerPerformanceCategory.GoalsScoring,
	'Player To Score In Both Halves': SoccerPerformanceCategory.GoalsScoring,
	'Player Assists': SoccerPerformanceCategory.GoalsScoring,

	'Total Cards': SoccerPerformanceCategory.CardsDiscipline,
	'1st Half Total Cards': SoccerPerformanceCategory.CardsDiscipline,
	'Team Total Cards': SoccerPerformanceCategory.CardsDiscipline,
	'1st Half Team Total Cards': SoccerPerformanceCategory.CardsDiscipline,
	'Player Cards': SoccerPerformanceCategory.CardsDiscipline,
	'Anytime Card Receiver': SoccerPerformanceCategory.CardsDiscipline,

	'Total Corners': SoccerPerformanceCategory.SetPiecesPossessions,
	'1st Half Total Corners': SoccerPerformanceCategory.SetPiecesPossessions,
	'2nd Half Total Corners': SoccerPerformanceCategory.SetPiecesPossessions,
	'Team Total Corners': SoccerPerformanceCategory.SetPiecesPossessions,
	'1st Half Team Total Corners': SoccerPerformanceCategory.SetPiecesPossessions,
	'Player Fouls': SoccerPerformanceCategory.SetPiecesPossessions,
	'Player Fouls Drawn': SoccerPerformanceCategory.SetPiecesPossessions,
};

export const SOCCER_PERFORMANCE_CATEGORY_BY_SEEDED_CATEGORY: Record<
	string,
	SoccerPerformanceCategory
> = {
	'Main Lines': SoccerPerformanceCategory.MatchOutcome,
	Handicap: SoccerPerformanceCategory.MatchOutcome,
	'Correct Score': SoccerPerformanceCategory.MatchOutcome,
	Totals: SoccerPerformanceCategory.GoalsScoring,
	'Team Props': SoccerPerformanceCategory.GoalsScoring,
	Corners: SoccerPerformanceCategory.SetPiecesPossessions,
	'Cards & Shots': SoccerPerformanceCategory.CardsDiscipline,
	'Goal Scorers': SoccerPerformanceCategory.GoalsScoring,
	'Player Props': SoccerPerformanceCategory.GoalsScoring,
};
